import React from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";

import HomePage from "../pages/HomePage";
import QuizPage from "../pages/QuizPage";

export default function Root() {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" exact component={HomePage} />
        <Route path="/quiz" exact component={QuizPage} />
        <Redirect path="*" to="/" />
      </Switch>
    </BrowserRouter>
  );
}
